import { useEffect, useState, useCallback } from "react";

import CloseButton from "../buttons/CloseButton";
import TextButton from "../buttons/TextButton";
import DialogTitle from "./DialogTitle";
import DialogWrapper from "./DialogWrapper";
import TextInput from "../inputs/TextInput";

const InputDialog = ({
  isOpen,
  label,
  title,
  submitText,
  onSubmit,
  onCancel,
  isSubmitLoading,
  initialValue,
  enableClearInputValueAfterSubmit,
  inputProps,
  disabled,
}) => {
  const [inputValue, setInputValue] = useState(initialValue || "");
  const [inputError, setInputError] = useState(false);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (inputError) return;
      onSubmit(inputValue);
      if (enableClearInputValueAfterSubmit) {
        setInputValue("");
      }
    },
    [enableClearInputValueAfterSubmit, inputValue, onSubmit, inputError],
  );

  const handleCancel = (e) => {
    e.preventDefault();
    onCancel();
  };

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  return isOpen ? (
    <DialogWrapper onClick={handleCancel}>
      <div
        className="relative bg-white rounded-xl w-[590px] px-[100px] pt-[65px] pb-[53px]"
        onClick={(e) => e.stopPropagation()}
      >
        <CloseButton onClick={handleCancel}></CloseButton>
        <div className="flex flex-col gap-y-[39px]">
          <DialogTitle title={title} />

          <TextInput
            label={label}
            value={inputValue || ""}
            onChange={setInputValue}
            onValidityChange={(valid) => {
              setInputError(!valid);
            }}
            disabled={disabled}
            {...inputProps}
          />

          <TextButton
            disabled={
              !inputValue ||
              isSubmitLoading ||
              inputError ||
              inputValue === initialValue ||
              disabled
            }
            className={"h-[56px]"}
            label={submitText}
            onClick={handleSubmit}
            isLoading={isSubmitLoading}
          />
        </div>
      </div>
    </DialogWrapper>
  ) : null;
};

export default InputDialog;
